import React from 'react';
import '../../../styles/documents/EditorModal.css';

type Props = {
  open: boolean;
  title?: string;
  onClose: () => void;
  onSave?: () => void;
  children?: React.ReactNode;
};

export default function EditorModal({ open, title = 'Edit document', onClose, onSave, children }: Props) {
  if (!open) return null;

  return (
    <div className="emodal">
      <div className="emodal__backdrop" onClick={onClose} />
      <div className="emodal__card" role="dialog" aria-modal="true" aria-label={title}>
        <div className="emodal__header">
          <div className="emodal__title">{title}</div>
          <button type="button" className="emodal__close" aria-label="Close" onClick={onClose}>✕</button>
        </div>

        <div className="emodal__body">{children}</div>

        <div className="emodal__footer">
          <button type="button" className="emodal__btn" onClick={onClose}>Close</button>
          <button
            type="button"
            className="emodal__btn emodal__btn--primary"
            onClick={() => (onSave ? onSave() : onClose())}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}